import { Box } from 'native-base';
import React from 'react';

export interface LateralProductBarProps {
  backgroundColor: string;
}

export const LateralProductBar: React.FC<LateralProductBarProps> = ({ backgroundColor }) => {
  return (
    <Box
      position="absolute"
      top={0}
      left={0}
      bottom={0}
      w={'4px'}
      backgroundColor={backgroundColor}
      borderTopLeftRadius={'full'}
      borderBottomLeftRadius={'full'}
    />
  );
};
